import { Container, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import LoadingBackdrop from 'src/components/ui-component/loading/LoadingBackdrop';
import { getLocalstorageToken } from '../../../context/AuthHelper';
import GetRecord from '../../../lib/api/GetRecord';
import { APIS } from '../../../lib/constants/apis';
import { DisplayDayAndFullDate } from '../../../utils/formats';
import { getFieldNamefromDataPath, removeDataKeys, removeNullDeep } from '../../../utils/helper';
import AntraegeInForderung from './structure/AntraegeInForderung';
import BeendeteForderung from './structure/BeendeteForderung';
import EInstellung from './structure/EInstellung';
import Nachrichten from './structure/Nachrichten';
import RegisrierungAbschliessen from './structure/RegistrierungAbschliessen';
import VorDerForderung from './structure/VorDerForderung';

// import Schemas
import Schema from 'src/lib/paths/organisation_FULL_Paths.json';
const P = Schema.attributes;

function MeinBereich() {
	const [isLoading, setIsLoading] = useState(true);

	const [orgaDetails, setOrgaDetails] = useState({});

	useEffect(() => {
		const fetchData = async () => {
			try {
				const res = await GetRecord(APIS.Organisation, get(getLocalstorageToken(), 'organisationId'), [
					getFieldNamefromDataPath(P.Bankdaten.path),
				]);
				if (res) {
					setOrgaDetails(removeNullDeep(removeDataKeys(get(res, 'data'))));
				}
			} finally {
				setIsLoading(false);
			}
		};
		fetchData();
	}, []);

	if (isLoading) return <LoadingBackdrop open={isLoading} />;

	return (
		<>
			<Container>
				<Stack direction={'row'} justifyContent={'space-between'}>
					<Typography variant='h3' component='h2'>
						{' '}
						Willkommen, {get(orgaDetails, P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path, '')}
					</Typography>
					<Typography variant='h3' component='h2'>
						{' '}
						{DisplayDayAndFullDate(new Date().toISOString())}
					</Typography>
				</Stack>
				<RegisrierungAbschliessen orgaDetails={orgaDetails} />
				<Grid container columns={{ xs: 1, sm: 2, md: 3 }} spacing={4}>
					<Grid xs={3} sm={1} md={1}>
						<VorDerForderung />
						<BeendeteForderung />
					</Grid>
					<Grid xs={3} sm={1} md={1}>
						<AntraegeInForderung />
						<EInstellung />
					</Grid>
					<Grid xs={3} sm={2} md={1}>
						<Nachrichten />
					</Grid>
				</Grid>
			</Container>
		</>
	);
}

export default MeinBereich;
